import React from 'react';

const ParentFilterContext = React.createContext({});

export const ParentFilterProvider = ParentFilterContext.Provider;

export default ParentFilterContext;
